// extracted by mini-css-extract-plugin
module.exports = {"whatsapp":"CTALink-module--whatsapp--1aQIu"};